import { useParams } from 'react-router-dom';
import { SidePanel, SidePanelType, ButtonPrimary, ButtonPseudo } from '@ui/src';
import { useAppSelector } from '@store';
import CreateCompanyOfficialForm from '../../../../components/corporate/overview/create-company-official-form';
import useCreateCompanyOfficial from '../hooks/use-create-company-official';
import { ApplicationSchemeType } from '../../../new-application/types';

const CreateCompanyOfficial = () => {
  const { applicationSchemes } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { countriesList: countries } = useAppSelector((state) => state.root);

  const { customerId } = useParams();

  const {
    panelIsOpen,
    handleClose,
    addNewCofInProgress,
    cofIsLoading,
    control,
    havingControl,
    errors,
    cofError,
    sumSubError,
    onSubmit,
  } = useCreateCompanyOfficial({
    customerId,
    applicationSchemes,
  });

  return (
    <SidePanel
      type={SidePanelType.Customers}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title="Create company official application"
      sidepanelExpandedKey="corporate-create-cof"
      footer={
        <>
          <ButtonPrimary
            text={
              addNewCofInProgress || cofIsLoading
                ? 'Loading...'
                : 'Create application'
            }
            onClick={onSubmit}
            bold
            disabled={addNewCofInProgress || cofIsLoading}
          />
          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
    >
      <CreateCompanyOfficialForm
        control={control}
        havingControl={havingControl}
        errors={errors}
        cofError={cofError}
        sumSubError={sumSubError}
        countries={countries}
        applicationSchemes={applicationSchemes
          ?.filter(
            (item) => item.type === ApplicationSchemeType.COMPANY_OFFICIAL,
          )
          ?.map((item) => ({ name: item.name, value: item.id }))}
      />
    </SidePanel>
  );
};

export default CreateCompanyOfficial;
